export default {
  confirmButton: 'Confirm',
};
